import { I18N_LOCALES } from '#/i18n/types/I18nLocale';

const homepagePaths = I18N_LOCALES.map((locale) => `/${locale}`);

export function onHomepage(pathname: string) {
  return homepagePaths.includes(pathname);
}
